<div class="input-panel d-flex">
    <div class="d-inline-block" ngbDropdown #emojiDrop="ngbDropdown">
        <button class="btn btn-light-grey btn-sm btn-icon p-1" type="button" ngbDropdownToggle>
            <span title="Emoji">😀</span>
        </button>
        <div ngbDropdownMenu aria-labelledby="inputPanel" class="{{emojiDrop.isOpen() ? 'opened-emojidropdown' : 'closed-emojidropdown'}}">
            <emoji-mart (emojiClick)="addEmoji($event)" [exclude]="[]" [sheetSize]="sheetSize" [darkMode]="false"></emoji-mart>
        </div>
    </div>
</div>